import { Author } from './books'
// Centralized current user data to ensure consistency across the application
export const currentUser: Author = {
  id: '1',
  name: 'Marco Rossi',
  image:
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80',
  type: 'fiction',
  genres: ['Fantasia', 'Avventura', 'Romanzo'],
  bio: 'Autore di bestseller con una passione per la narrativa fantastica. Ha pubblicato oltre 10 romanzi tradotti in diverse lingue.',
  followers: 2400,
  works: 12,
  awards: 3,
  username: 'marcorossi',
  socialLinks: {
    instagram: 'https://instagram.com/marcorossi',
    twitter: 'https://twitter.com/marcorossi',
    facebook: 'https://facebook.com/marcorossi',
    youtube: 'https://youtube.com/marcorossi',
  },
}
